module.exports = __webpack_public_path__ + "img/title-test.231d68c8.jpg";